import React from "react"
import { Layout } from "../components/layout"
import SEO from "../components/seo"
import { Link, graphql } from "gatsby"
import { linkResolver } from '../utils/linkResolver'

export const query = graphql`
  {
    prismic {
      allTopics {
        edges {
          node {
            description
            title
            _meta {
              uid
              type
            }
          }
        }
      }
    }
  }
`

const topicsPage = ({ data }) => (
  <div className="body">
    <Layout>
      <SEO title="Topics" />
      <div className="grid-child intro">
        <div className="text-wrapper">
          <h1>Topics.</h1>
          <p className="page-paragraph"><strong>‍</strong>The less technical side of my internship was spent pondering these three absurdly disconnected ideas that seemed like they had enough weight to become topics I would keep track of throughout my internship:</p>
        </div>
      </div>
      <div className="grid-child nopadding topics">
        {data.prismic.allTopics.edges.map(({ node: topic }, i) => (
          <Link to={linkResolver(topic._meta)} key={i} className="topic w-inline-block">
            <h4 className="card-title">{topic.title[0].text}</h4>
            <p>{topic.description[0].text}</p>
          </Link>
        ))}
      </div>
    </Layout>
  </div>
)
export default topicsPage